import { render, staticRenderFns } from "./InactiveEmployeesReport.html?vue&type=template&id=12b5c2f8&external"
import script from "./InactiveEmployeesReport.vue?vue&type=script&lang=js"
export * from "./InactiveEmployeesReport.vue?vue&type=script&lang=js"
import style0 from "./InactiveEmployeesReport.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports